import TableCardv2 from "../../components/TableCardv2";
import ArticleIcon from "@mui/icons-material/Article";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Tabs,
  IconButton,
  Button,
  Tab,
} from "@mui/material";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import TabRelatorios from "./TabRelatorios";
import TabColunas from "./TabColunas";
import TabFiltros from "./TabFiltros";
import styles from "./styles.module.css";
import { RelatoriosContext } from "./RelatoriosContext";
import BlueButton from "../../components/BlueButton";
import SnackBar from "../../components/SnackBar";
import ModalConfirmacao from "../../components/ModalConfirmacao";
import {
  atualizarRelatorio,
  buscarRelatorios,
  buscarRelatoriosPorTexto,
  cadastrarRelatorio,
  excluirRelatorio,
} from "../../services/api-relatorios.service";
import { debounce } from "lodash";

const header = {
  icon: <ArticleIcon fontSize="1rem" />,
  title: "Relatórios",
};

const Relatorios = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [relatoriosRows, setRelatoriosRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [idRelatorio, setIdRelatorio] = useState(null);
  const [value, setValue] = useState("relatorios");
  const [tabContent, setTabContent] = useState(<TabRelatorios />);
  const {
    dadosFiltros,
    setDadosFiltros,
    dadosColunas,
    setDadosColunas,
    dadosRelatorios,
    setDadosRelatorios,
    resetDados,
  } = useContext(RelatoriosContext);

  const colorTab = {
    title: {
      "&.Mui-selected": {
        color: "#18316e",
      },
    },
    indicator: {
      "& .MuiTabs-indicator": {
        backgroundColor: "#18316e",
      },
    },
  };

  const columns = useMemo(
    () => [
      { key: "id", label: "ID", align: "center", width: "72px" },
      { key: "nome", label: "Nome do Relatório" },
    ],
    []
  );

  const handleOpenModalDelete = useCallback((row) => {
    setIdRelatorio({ id: row.idRelatorio, nome: row.nome });
    setOpenModalDelete(true);
  }, []);

  const handleOpenModal = useCallback((row) => {
    if (row?.idRelatorio) {
      setDadosColunas(row.colunas);
      setDadosFiltros(
        row.filtros.map((filtro) => ({
          ...filtro,
          tipoDado: filtro.tipoDado || null,
          codCombo: filtro.codCombo || null,
        }))
      );
      setDadosRelatorios((prev) => ({
        ...prev,
        nome: row.nome,
        script: row.script,
        codigoRelatorio: row.codigoRelatorio,
        apuracao: row.apuracao || false,
        idTipoRelatorio: row.tipoRelatorio?.idTipoRelatorio || null,
        tipoRelatorio: {
          id: row.tipoRelatorio?.idTipoRelatorio?.toString(),
          nome: row.tipoRelatorio?.descricao,
        },
      }));
      setIdRelatorio({ id: row.idRelatorio, nome: row.nome });
      setValue("relatorios");
    } else {
      resetDados();
      setIdRelatorio(null);
      setValue("relatorios");
    }
    setOpenModal(true);
  }, [setDadosColunas, setDadosFiltros, setDadosRelatorios, resetDados]);

  const montarLinhas = useCallback(
    (lista) =>
      (lista || []).map((item) => ({
        id: item.idRelatorio,
        nome: item.nome,
        btn: [
          {
            icon: <EditIcon />,
            title: "Editar",
            onClick: () => handleOpenModal(item),
            variant: "primary",
          },
          {
            icon: <DeleteIcon />,
            title: "Excluir",
            onClick: () => handleOpenModalDelete(item),
            variant: "danger",
          },
        ],
      })),
    [handleOpenModal, handleOpenModalDelete]
  );

  const handleBuscarDados = useCallback(async () => {
    try {
      setLoading(true);
      const response = await buscarRelatorios();
      const lista = response?.relatorios ?? [];
      setRelatoriosRows(montarLinhas(lista));
    } catch (error) {
      setObjSnackBar({
        type: "error",
        msg:
          error.response?.data?.mensagem ||
          error.response?.data?.message ||
          "Erro ao carregar relatórios.",
      });
    } finally {
      setLoading(false);
    }
  }, [montarLinhas]);

  useEffect(() => {
    handleBuscarDados();
  }, [handleBuscarDados]);

  useEffect(() => {
    switch (value) {
      case "relatorios":
        setTabContent(<TabRelatorios />);
        break;
      case "colunas":
        setTabContent(<TabColunas />);
        break;
      case "filtros":
        setTabContent(<TabFiltros />);
        break;
      default:
        break;
    }
  }, [value]);

  const handleChangeTab = (_, newValue) => {
    setValue(newValue);
  };

  const handleAbrirModalNovo = useCallback(() => {
    resetDados();
    setIdRelatorio(null);
    setValue("relatorios");
    setOpenModal(true);
  }, [resetDados]);

  const handleCloseModal = () => {
    setOpenModal(false);
    setIdRelatorio(null);
    resetDados();
  };

  const handleCloseModalDelete = () => {
    setOpenModalDelete(false);
    setIdRelatorio(null);
  };

  const handleSubmit = async () => {
    const todosCamposColunas = dadosColunas.every(
      (item) => item.nome && item.variavel && item.script
    );
    const todosCamposFiltros = dadosFiltros.every(
      (item) => item.nome && item.variavel && item.script
    );

    if (!dadosRelatorios.nome) {
      setObjSnackBar({ type: "error", msg: "Nome do relatório não preenchido!" });
      return;
    }
    if (!dadosRelatorios.idTipoRelatorio) {
      setObjSnackBar({ type: "error", msg: "Tipo do relatório não preenchido!" });
      return;
    }
    if (!todosCamposColunas) {
      setObjSnackBar({
        type: "error",
        msg: "Ainda existem campos vazios em Colunas!",
      });
      return;
    }
    if (!todosCamposFiltros) {
      setObjSnackBar({
        type: "error",
        msg: "Ainda existem campos vazios em Filtros!",
      });
      return;
    }

    const body = {
      relatorio: dadosRelatorios,
      colunas: dadosColunas,
      filtros: dadosFiltros,
    };
    try {
      if (idRelatorio) {
        await atualizarRelatorio(body, idRelatorio.id);
        setObjSnackBar({ type: "success", msg: "Relatório atualizado com sucesso!" });
      } else {
        await cadastrarRelatorio(body);
        setObjSnackBar({ type: "success", msg: "Relatório cadastrado com sucesso!" });
      }
      await handleBuscarDados();
      handleCloseModal();
    } catch (error) {
      setObjSnackBar({
        type: "error",
        msg:
          error.response?.data?.mensagem ||
          error.response?.data?.message ||
          "Erro ao salvar relatório.",
      });
    }
  };

  const handleConfirmarExclusao = async () => {
    try {
      await excluirRelatorio(idRelatorio.id);
      setObjSnackBar({ type: "success", msg: "Relatório excluído com sucesso!" });
      await handleBuscarDados();
      handleCloseModalDelete();
      handleCloseModal();
    } catch (error) {
      setObjSnackBar({
        type: "error",
        msg:
          error.response?.data?.mensagem ||
          error.response?.data?.message ||
          "Erro ao excluir relatório.",
      });
    }
  };

  const handlePesquisaPorTexto = useCallback(
    async (texto) => {
      setLoadingTable(true);
      try {
        if (texto) {
          const response = await buscarRelatoriosPorTexto(texto);
          const lista = response?.relatorios ?? [];
          setRelatoriosRows(montarLinhas(lista));
        } else {
          const response = await buscarRelatorios();
          const lista = response?.relatorios ?? [];
          setRelatoriosRows(montarLinhas(lista));
        }
      } catch (error) {
        setRelatoriosRows([]);
        setObjSnackBar({
          type: "error",
          msg:
            error.response?.data?.mensagem ||
            error.response?.data?.message ||
            "Erro ao buscar relatórios.",
        });
      } finally {
        setLoadingTable(false);
      }
    },
    [montarLinhas]
  );

  const handleDebounce = useMemo(
    () => debounce((v) => handlePesquisaPorTexto(v), 300),
    [handlePesquisaPorTexto]
  );

  useEffect(() => {
    return () => handleDebounce.cancel();
  }, [handleDebounce]);

  const tituloModal = idRelatorio ? "Editar relatório" : "Novo relatório";

  return (
    <>
      <div className={styles.container}>
        <TableCardv2
          header={header}
          columns={columns}
          data={relatoriosRows}
          debounce={handleDebounce}
          loading={loading}
          loadingTable={loadingTable}
          searchPlaceholder="Buscar por nome ou ID"
        />
      </div>

      <Fab
        sx={{
          background: "#4b6fc0",
          bottom: 40,
          right: 20,
          position: "fixed",
          zIndex: 1000,
          "&:hover": {
            backgroundColor: "#4b6fc0",
          },
        }}
        aria-label="Novo relatório"
        onClick={handleAbrirModalNovo}
      >
        <AddIcon sx={{ color: "#fff" }} />
      </Fab>

      <Dialog
        onClose={handleCloseModal}
        open={openModal}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: "#18316e",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <span>{tituloModal}</span>
          <IconButton
            aria-label="fechar"
            onClick={handleCloseModal}
            sx={{ color: "white", padding: 0.5 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2, pb: 0.5 }}>
          <Tabs
            value={value}
            onChange={handleChangeTab}
            sx={colorTab.indicator}
            variant="fullWidth"
          >
            <Tab value="relatorios" label="Relatório" sx={colorTab.title} />
            <Tab value="colunas" label="Colunas" sx={colorTab.title} />
            <Tab value="filtros" label="Filtros" sx={colorTab.title} />
          </Tabs>
          <div className={styles.contentTab}>{tabContent}</div>
        </DialogContent>
        <DialogActions sx={{ px: 2, py: 1, pt: 0.5, gap: 1 }}>
          <Button onClick={handleCloseModal} color="inherit" variant="outlined">
            Cancelar
          </Button>
          <BlueButton
            textValue="Salvar"
            contentIcon={<SendIcon />}
            clickFunction={handleSubmit}
          />
        </DialogActions>
      </Dialog>

      <ModalConfirmacao
        open={openModalDelete}
        onClose={handleCloseModalDelete}
        onConfirm={handleConfirmarExclusao}
        title="Excluir relatório"
        message={`Tem certeza que deseja excluir o relatório "${idRelatorio?.nome ?? ""}"? Esta ação não pode ser desfeita.`}
        confirmText="Excluir"
        cancelText="Cancelar"
        severity="error"
      />

      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />
    </>
  );
};

export default Relatorios;
